<template>
  <div>
    <pcHeader></pcHeader>
    <div class="pc_balance_content">
      <div class="pc_balance_address">
        <div class="pc_balance_address_title clearfix_">
          <div class="fl pc_balance_address_title_txt">收货地址</div>
          <div class="fl clearfix_ pc_balance_address_title_extraction">
            <el-checkbox v-model="selfExtraction" label="上门自提" border></el-checkbox>
          </div>
          <div @click="moreAddressFn" class="fr pc_balance_address_more">{{moreAddress?'收起更多':'显示更多'}}</div>
        </div>
        <div v-show="!selfExtraction" :style="{height:(moreAddress?'auto':'152px')}" class="pc_balance_address_list clearfix_">
          <div @click="changeAddress(item)" v-for="(item,index) in addressList" :key="index" :class="{'pc_balance_address_item_active':item.status==1}" class="fl pc_balance_address_item">
            <div class="pc_balance_address_item_txt clearfix_">
              <div class="pc_balance_address_item_name fl">{{item.consignee}}</div>
              <div class="pc_balance_address_item_phone fl">{{item.mobilePhone}}</div>
            </div>
            <div class="pc_balance_address_item_address1">{{item.areaText}}</div>
            <div class="pc_balance_address_item_address2">{{item.address}}</div>
            <div @click="modifyAddressShowFn(item)" class="pc_balance_address_item_modify"></div>
          </div>
        </div>
      </div>
      <div class="pc_balance_distribution">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">配送时间</div>
        </div>
        <div class="pc_balance_distribution_list clearfix_">
          <div @click="changeDistribution(item.id)" v-for="(item,index) in distributionList" :key="index" :class="{'pc_balance_distribution_item_active':distributionType==item.id}" class="fl pc_balance_distribution_item">{{item.name}}</div>
        </div>
      </div>
      <div class="pc_balance_pay_type">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">支付方式</div>
        </div>
        <div class="pc_balance_pay_type_box">
          <div v-show="isUseMemberCardRuleBalance==1" class="pc_balance_pay_type_card clearfix_">
            <div class="fl pc_balance_pay_type_card_check">
              <el-checkbox :disabled="storedValueCardDisabled" v-model="storedValueCardChecked" label="储值卡" border></el-checkbox>
            </div>
            <div class="fl pc_balance_pay_type_card_txt">储值卡余额：<span>{{balanceData.cardRuleMoney}} <span v-show="balanceData.showSaleScale">/</span> {{balanceData.showSaleScale}}</span></div>
          </div>
          <div  class="pc_balance_pay_type_card clearfix_">
            <div class="fl pc_balance_pay_type_card_check">
              <el-checkbox @change="changeMemberMoneyChecked" :disabled="memberMoneyDisabled" v-model="memberMoneyChecked" label="余额" border></el-checkbox>
            </div>
            <div class="fl pc_balance_pay_type_card_txt">账户余额：<span>{{balanceData.memberMoney}}</span></div>
          </div>
          <div class="pc_balance_pay_type_list clearfix_">
            <div @click="changePayType(item)" v-for="(item,index) in payTypeList" :key="index" :class="{'pc_balance_pay_type_item_active':item.isChecked}" class="fl pc_balance_pay_type_item">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="pc_balance_pay_order">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">订单明细</div>
        </div>
        <div class="pc_balance_pay_order_txt_box clearfix_">
          <div class="fl pc_balance_pay_order_txt_name">商品名称</div>
          <div class="fl pc_balance_pay_order_txt_price1">单价</div>
          <div class="fl pc_balance_pay_order_txt_num">数量</div>
          <div class="fl pc_balance_pay_order_txt_price2">小计</div>
          <div class="fl pc_balance_pay_order_txt_discount">优惠方式</div>
        </div>
        <div class="pc_balance_pay_order_goods_list">
          <div v-for="(item,index) in goodsList" :key="index" class="pc_balance_pay_order_goods_item clearfix_">
            <div class="fl pc_balance_pay_order_goods_item_pic"><img :src="item.pic?item.pic:noImg" alt=""></div>
            <div class="fl pc_balance_pay_order_goods_item_name">{{item.goodsName}}</div>
            <div class="fl pc_balance_pay_order_goods_item_attr">{{item.goodsUnitName}} {{item.property1}}</div>
            <div class="fl pc_balance_pay_order_goods_item_price1">{{item.salesMoney}}</div>
            <div class="fl pc_balance_pay_order_goods_item_num">{{item.num}}</div>
            <div class="fl pc_balance_pay_order_goods_item_price2">{{item.totalPrice}}</div>
            <div class="fl pc_balance_pay_order_goods_item_discount"><span v-show="parseInt(item.privilege)">优惠{{item.privilege}}元</span> <span v-show="parseInt(item.score)">{{item.score}}分</span></div>
          </div>
        </div>
        <div class="pc_balance_pay_order_discount clearfix_">
          <div class="fr pc_balance_pay_order_discount_list">
            <div v-show="parseInt(balanceData.privilege)" class="pc_balance_pay_order_discount_item clearfix_">
              <div class="fl pc_balance_pay_order_discount_item_txt">单品优惠</div>
              <div class="fl pc_balance_pay_order_discount_item_price">¥{{balanceData.privilege}}</div>
            </div>
            <div v-show="parseInt(balanceData.memberPrivilege)" class="pc_balance_pay_order_discount_item clearfix_">
              <div class="fl pc_balance_pay_order_discount_item_txt">会员优惠</div>
              <div class="fl pc_balance_pay_order_discount_item_price">¥{{balanceData.memberPrivilege}}</div>
            </div>
            <div v-show="parseInt(balanceData.cardRulePrivilege)" class="pc_balance_pay_order_discount_item clearfix_">
              <div class="fl pc_balance_pay_order_discount_item_txt">储值优惠</div>
              <div class="fl pc_balance_pay_order_discount_item_price">¥{{balanceData.cardRulePrivilege}}</div>
            </div>
            <div v-show="parseInt(balanceData.pmnPricePrivilege)" class="pc_balance_pay_order_discount_item clearfix_">
              <div class="fl pc_balance_pay_order_discount_item_txt">商品优惠</div>
              <div class="fl pc_balance_pay_order_discount_item_price">¥{{balanceData.pmnPricePrivilege}}</div>
            </div>
            <div class="pc_balance_pay_order_discount_item clearfix_">
              <div class="fl pc_balance_pay_order_discount_item_txt"><span>{{balanceData.totalNum?balanceData.totalNum:balanceData.num}}</span> 件商品，商品总额</div>
              <div class="fl pc_balance_pay_order_discount_item_price">¥{{balanceData.goodsAmount}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="giftGoodsList.length" class="pc_balance_gift">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">赠品明细</div>
        </div>
        <div class="pc_balance_gift_txt_box clearfix_">
          <div class="fl pc_balance_gift_txt_name">商品名称</div>
          <div class="fl pc_balance_gift_txt_num">数量</div>
          <div class="fl pc_balance_gift_txt_price">总价</div>
        </div>
        <div class="pc_balance_pay_order_goods_list">
          <div v-for="(item,index) in giftGoodsList" :key="index" class="pc_balance_pay_order_goods_item clearfix_">
            <div class="fl pc_balance_pay_order_goods_item_pic"><img :src="item.pic?item.pic:noImg" alt=""></div>
            <div class="fl pc_balance_pay_order_goods_item_name">{{item.goodsName}}</div>
            <div class="fl pc_balance_pay_order_goods_item_attr">{{item.property1}}</div>
            <div class="fl pc_balance_pay_order_goods_item_num">{{item.num}}</div>
            <div class="fl pc_balance_pay_order_goods_item_price1">{{item.addPrice}}</div>
          </div>
        </div>
      </div>
      <div v-show="promotionList.length" class="pc_balance_promotion">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">促销明细</div>
        </div>
        <div class="pc_balance_promotion_txt_box clearfix_">
          <div class="fl pc_balance_promotion_txt">活动明细</div>
          <div class="fl pc_balance_promotion_txt">明细内容</div>
          <div class="fl pc_balance_promotion_txt">活动名称</div>
          <div class="fl pc_balance_promotion_txt">类型</div>
        </div>
        <div class="pc_balance_promotion_list">
          <div v-for="(item,index) in promotionList" :key="index" class="pc_balance_promotion_item clearfix_">
            <div class="fl pc_balance_promotion_item_txt" :title="item.condition+item.method+item.pmnPrivilege">{{item.condition}}{{item.method}}{{item.pmnPrivilege}}</div>
            <div class="fl pc_balance_promotion_item_txt"><span v-show="item.giftNum">{{item.giftNum}} </span> <span v-show="parseFloat(item.money)"> {{item.money}} </span> <span v-show="item.score"> {{item.score}} </span></div>
            <div class="fl pc_balance_promotion_item_txt"  :title="item.name">{{item.name}}</div>
            <div class="fl pc_balance_promotion_item_txt">{{item.type}}</div>
          </div>
        </div>
      </div>
      <div v-show="couponList.length" class="pc_balance_coupon">
        <div class="pc_balance_address_title">
          <div class="pc_balance_address_title_txt">优惠券</div>
        </div>
        <div class="pc_balance_coupon_list clearfix_">
          <div v-for="(item,index) in couponList" :key="index" class="fl pc_balance_coupon_item clearfix_">
            <div @click="changeCouponChecked(item)" class="fl pc_balance_coupon_item_radio"><img :src="item.checkFlag?'http://img.source.9188cn.com/pc_balance_coupon_checked_active.png':'http://img.source.9188cn.com/pc_balance_coupon_checked.png'" alt=""></div>
            <div class="fl pc_balance_coupon_item_box">
              <div class="pc_balance_coupon_item_bg">
                <img v-show="parseFloat(item.money)>0&&parseFloat(item.money)<50" src="http://img.source.9188cn.com/pc_balance_coupon250_1.png" alt="">
                <img v-show="parseFloat(item.money)>=50&&parseFloat(item.money)<100" src="http://img.source.9188cn.com/pc_balance_coupon250_2.png" alt="">
                <img v-show="parseFloat(item.money)>=100" src="http://img.source.9188cn.com/pc_balance_coupon250_3.png" alt="">
              </div>
              <div class="pc_balance_coupon_item_rmb">¥</div>
              <div v-show="item.privilege.toString().length==1" class="pc_balance_coupon_item_price1">{{item.privilege}}</div>
              <div v-show="item.privilege.toString().length==2" class="pc_balance_coupon_item_price2">{{item.privilege}}</div>
              <div v-show="item.privilege.toString().length==3" class="pc_balance_coupon_item_price3">{{item.privilege}}</div>
              <div v-show="item.privilege.toString().length==4" class="pc_balance_coupon_item_price4">{{item.privilege}}</div>
              <div class="pc_balance_coupon_item_txt1"><span>{{item.condition}}</span> <span style="color:#a75212;">{{item.goodsNum}}</span> <span>{{item.method}}可用</span></div>
              <div class="pc_balance_coupon_item_time">{{item.startTime}}至{{item.endTime}}</div>
              <div class="pc_balance_coupon_item_txt2">面额 {{item.money}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pc_balance_discount clearfix_">
        <div class="fl pc_balance_discount_remark clearfix_">
          <div class="fl pc_balance_discount_remark_txt">给卖家留言：</div>
          <div class="fl pc_balance_discount_remark_input"><textarea v-model="msg" maxlength="200" name="" id="" cols="193" rows="5"></textarea></div>
        </div>
        <div class="fl pc_balance_discount_list clearfix_">
          <div class="fl pc_balance_discount_list1">
            <div v-show="balanceData.totalScore" class="pc_balance_discount_list1_item clearfix_">
              <span class="fl">积分</span>
              <span class="fr">{{balanceData.totalScore}}</span>
            </div>
            <div v-show="couponData.sendCouponNum" class="pc_balance_discount_list1_item clearfix_">
              <span class="fl">优惠券</span>
              <span class="fr">{{couponData.sendCouponNum}}</span>
            </div>
            <div v-show="couponData.totalGiftNum" class="pc_balance_discount_list1_item clearfix_">
              <span class="fl">赠品</span>
              <span class="fr">{{couponData.totalGiftNum}}</span>
            </div>
          </div>
          <div class="fr pc_balance_discount_list2">
            <div class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">商品总额</span>
              <span class="fr">¥ {{balanceData.goodsAmount}}</span>
            </div>
            <div v-show="parseInt(balanceData.pmnGoodsPrivilege)" class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">品类优惠</span>
              <span class="fr">¥ {{balanceData.pmnGoodsPrivilege}}</span>
            </div>
            <div v-show="parseInt(balanceData.pmnOrderPrivilege)" class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">订单优惠</span>
              <span class="fr">¥ {{balanceData.pmnOrderPrivilege}}</span>
            </div>
            <div v-show="parseInt(couponDiscount)" class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">优惠券优惠</span>
              <span class="fr">¥ {{couponDiscount}}</span>
            </div>
            <div v-show="parseInt(couponData.pmnAddPricePrivilege)" class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">加价金额</span>
              <span class="fr">¥ {{couponData.pmnAddPricePrivilege}}</span>
            </div>
            <div class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">运费</span>
              <span v-show="noFreight"  class="fr ">¥ {{noFreightNum}}</span>
              <span v-show="!noFreight" class="fr">¥ {{freight}}</span>
              <span v-show="parseInt(difference)" class="pc_balance_discount_list2_item_txt">还差{{difference}}包邮&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div class="pc_balance_discount_list2_item clearfix_">
              <span class="fl">商品数量</span>
              <span class="fr">{{totalNum}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pc_balance_price">
        <div class="pc_balance_total_price">实付金额： <span>{{totalAmount}}</span></div>
        <div class="pc_balance_price_address">
          <span>收货地址：{{detailedAddress}}</span>
          <span>收货人：{{consignee}}</span>
          <span>电话：{{mobilePhone}}</span>
        </div>
      </div>
      <div class="pc_balance_price_btn clearfix_">
        <div @click="submit" class="fr">提交订单</div>
      </div>
      <div v-show="maskShow" class="pc_balance_mask">
        <div v-show="modifyAddressShow" class="pc_balance_modify_address">
          <div class="pc_balance_modify_address_title_box">
            <div class="pc_balance_modify_address_title">修改收货地址</div>
            <div @click="modifyAddressHideFn" class="pc_balance_modify_address_close">×</div>
          </div>
          <div class="pc_balance_modify_address_content">
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt"><span>* </span>所在地：</div>
              <div class="fl pc_balance_modify_address_item_location clearfix_">
                <div class="fl pc_balance_modify_address_item_location_item">
                  <div @click="changeAddressCity(1)" class="pc_balance_modify_address_item_location_item_txt">{{proName?proName:'--请选择--'}}</div>
                  <div v-show="proListShow" class="pc_balance_modify_address_item_location_val_list">
                    <div @click="changeAddressCityVal(1,item)" v-for="(item,index) in proList" :key="index" class="pc_balance_modify_address_item_location_val_list_val">{{item.name}}</div>
                  </div>
                </div>
                <div class="fl pc_balance_modify_address_item_location_item">
                  <div @click="changeAddressCity(2)" class="pc_balance_modify_address_item_location_item_txt">{{cityName?cityName:'--请选择--'}}</div>
                  <div v-show="cityListShow" class="pc_balance_modify_address_item_location_val_list">
                    <div @click="changeAddressCityVal(2,item)" v-for="(item,index) in cityList" :key="index" class="pc_balance_modify_address_item_location_val_list_val">{{item.name}}</div>
                  </div>
                </div>
                <div class="fl pc_balance_modify_address_item_location_item">
                  <div @click="changeAddressCity(3)" class="pc_balance_modify_address_item_location_item_txt">{{countyName?countyName:'--请选择--'}}</div>
                  <div v-show="countyListShow" class="pc_balance_modify_address_item_location_val_list">
                    <div @click="changeAddressCityVal(3,item)" v-for="(item,index) in countyList" :key="index" class="pc_balance_modify_address_item_location_val_list_val">{{item.name}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt"><span>* </span>收货人：</div>
              <div class="fl pc_balance_modify_address_item_input"><input v-model="modifyConsignee" type="text"></div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt">座机：</div>
              <div class="fl pc_balance_modify_address_item_input"><input v-model="landline" type="text"></div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt"><span>* </span>联系电话：</div>
              <div class="fl pc_balance_modify_address_item_input"><input maxlength="11" v-model="modifyMobilePhone" type="number"></div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt">邮政编码：</div>
              <div class="fl pc_balance_modify_address_item_input"><input v-model="postalCode" type="number"></div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt"><span>* </span>详细地址：</div>
              <div class="fl pc_balance_modify_address_item_textarea"><textarea v-model="modifyDetailAddress" maxlength="50" ref="textarr" contenteditable="true"></textarea></div>
            </div>
            <div class="pc_balance_modify_address_item clearfix_">
              <div class="fl pc_balance_modify_address_item_txt"><span>* </span>默认：</div>
              <div class="fl pc_balance_modify_address_item_switch"><el-switch v-model="modifyAddressChecked" active-color="#13ce66" inactive-color="#ff4949"></el-switch></div>
            </div>
          </div>
          <div class="pc_balance_modify_address_btn">
            <div @click="modifyAddressFn">修改地址</div>
            <div v-show="false" @click="saveaddress">新增地址</div>
          </div>
        </div>
        <div v-show="addPirceGoodsShow" class="pc_balance_addPriceGoods">
          <div class="pc_balance_addPriceGoods_title clearfix_">
            <div class="fl pc_balance_addPriceGoods_title_txt">加价换购</div>
            <div @click="addPirceGoodsClose" class="fr pc_balance_addPriceGoods_title_close"><img src="http://img.source.9188cn.com/pc_balance_close.png" alt=""></div>
          </div>
          <div class="pc_balance_addPriceGoods_txt clearfix_">
            <div class="fl pc_balance_addPriceGoods_txt_name">商品名称</div>
            <div class="fl pc_balance_addPriceGoods_txt_num">数量</div>
            <div class="fl pc_balance_addPriceGoods_txt_price">加价金额</div>
          </div>
          <div class="pc_balance_addPriceGoods_list">
            <div v-for="(item,index) in addPriceList" :key="index" class="pc_balance_addPriceGoods_item clearfix_">
              <div @click="changeAddPriceChecked(item)" class="fl pc_balance_addPriceGoods_item_radio">
                <img v-show="item.checkFlag==0" src="http://img.source.9188cn.com/pc_balance_coupon_checked.png" alt="">
                <img v-show="item.checkFlag==1" src="http://img.source.9188cn.com/pc_balance_coupon_checked_active.png" alt="">
              </div>
              <div class="fl pc_balance_addPriceGoods_item_pic"><img :src="item.pic" alt=""></div>
              <div class="fl pc_balance_addPriceGoods_item_name">
                <div class="pc_balance_addPriceGoods_item_name_txt1">{{item.goodsName}}</div>
                <div class="pc_balance_addPriceGoods_item_name_txt2">{{item.property1}}</div>
              </div>
              <div class="fl pc_balance_addPriceGoods_item_num">{{item.num}}</div>
              <div class="fl pc_balance_addPriceGoods_item_price">{{item.addPrice}}</div>
            </div>
          </div>
          <div class="pc_balance_addPriceGoods_btn">
            <div class="clearfix_ pc_balance_addPriceGoods_btn_auto">
              <div @click="addPirceGoodsClose" class="fl pc_balance_addPriceGoods_btn1">取消</div>
              <div @click="couponRequest" class="fl pc_balance_addPriceGoods_btn1 pc_balance_addPriceGoods_btn2">确认</div>
            </div>
          </div>
        </div>
        <div v-show="passwordShow" class="pc_balance_password_box">
          <div class="pc_balance_password_title">下单密码</div>
          <div class="pc_balance_password">
            <div class="pwd-control" id="payPwd_">
              <div class="pc_balance_password_num">
                <div class="flex-1 item">
                  <input maxlength="1" autofocus="autofocus" type="tel">
                </div>
                <div class="flex-1 item">
                  <input maxlength="1" type="tel">
                </div>
                <div class="flex-1 item">
                  <input maxlength="1" type="tel">
                </div>
                <div class="flex-1 item">
                  <input maxlength="1" type="tel">
                </div>
                <div class="flex-1 item">
                  <input maxlength="1" type="tel">
                </div>
                <div class="flex-1 item">
                  <input maxlength="1" type="tel">
                </div>
              </div>
            </div>
            <input v-model="pwd" type='hidden' name='payPassword'>
            <div class="pc_balance_btn_box">
              <el-button type="warning" @click="balanceFn()">确认</el-button>
              <el-button type="info" @click="passwordHideFn">取消</el-button>
            </div>
          </div>
        </div>
        <div v-show="wxPayShow" class="pc_balance_wx">
          <div class="pc_balance_wx_img"><img :src="wxPayUrl" alt=""></div>
          <div class="pc_balance_wx_close"><img src="http://img.source.9188cn.com/pc_balance_close.png" alt=""></div>
          <div class="pc_balance_wx_txt">微信扫码支付</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime,sha1 } from '../../assets/js/public.js'
import payPwd from '../../assets/js/payPwd.js'
import pcHeader from '@/components/index/search'
export default {
  inject:['reload'],
  data(){
    return {
      distributionList:[
        {name:'所有时间均可送',id:'1'},
        {name:'仅上班时间可送',id:'2'},
        {name:'仅休息时间可送',id:'3'}
      ],
      payTypeList:[
        {name:"微信",id:"3",isShow:false,isChecked:false},
        {name:"支付宝",id:"6",isShow:false,isChecked:false},
        {name:"货到付款",id:"1",isShow:false,isChecked:false}
      ],
      distributionType:1,
      goodsList:[],
      noImg:require("@/assets/img/aa.png"),
      addressList:[],
      addressTotal:null,
      isUseMemberCardRuleDiscount:0,
      isUseMemberCardRuleBalance:0,
      storedValueCardChecked:false,
      storedValueCardDisabled:false,
      memberMoneyDisabled:false,
      payTypeDisabled:false,
      payTypeMode:-1,
      memberMoneyChecked:false,
      balanceData:{},
      giftGoodsList:[],
      couponList:[],
      couponData:{},
      couponDiscount:0,
      freight:'',
      totalNum:0,
      promotionList:[],
      totalAmount:'',
      consignee:'',
      mobilePhone:'',
      addressId:'',
      detailedAddress:'',
      maskShow:false,
      modifyAddressShow:false,
      proName:'',
      proId:'',
      proList:[],
      proListShow:false,
      cityName:'',
      cityId:'',
      cityList:[],
      cityListShow:false,
      countyName:'',
      countyId:'',
      countyList:[],
      countyListShow:false,
      modifyConsignee:'',
      landline:'',
      modifyMobilePhone:'',
      postalCode:'',
      modifyDetailAddress:'',
      modifyAddressChecked:true,
      moreAddress:false,
      selfExtraction:false,
      addPriceList:[],
      addPirceGoodsShow:false,
      isFreight:false,
      difference:0,
      noFreight:false,
      noFreightNum:0,
      msg:'',
      pwd:'',
      passwordShow:false,
      outTradeNo:'',
      time:12,
      wxPayShow:false,
      wxPayUrl:'',
    }
  },
  components:{
    pcHeader
  },
  mounted:function(){
    var t_=this
    t_.isUseMemberCardRuleDiscount=t_.$route.query.isUseMemberCardRuleDiscount
    t_.isUseMemberCardRuleBalance=t_.$route.query.isUseMemberCardRuleBalance
    t_.getAddressByMemberId()
    t_.getPayType()
    if(t_.$route.query.confirmTeamId){
      t_.teamBalance()
    }else{
      t_.toBalance()
    }
  },
  methods:{
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      return window.open(href.href,'_blank')
    },
    goSignIn:function(){
      localStorage.removeItem('tamp')
      localStorage.removeItem('name')
      return this.$router.push({
        name: 'loginHome',
        query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
      });
    },
    fn:function(){
      var t_=this
      setTimeout(function(){
        t_.time=--t_.time
        t_.payment()
        if(t_.time>0){
          t_.fn()
        }
        if(t_.time==0){
          t_.$router.push({name:'paySuccess',query:{outTradeNo:t_.outTradeNo}})
        }
      },5000,t_)
    },
    payment:function(){
      var t_=this
      var data0bj=({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      })
      if(t_.outTradeNo)data0bj.outTradeNo=t_.outTradeNo
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/payment`,data0bj).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          if(res.data.data.status==2){
            t_.$router.push({name:'paySuccess',query:{outTradeNo:t_.outTradeNo}})
          }
        }else if(res.data.code==-550){
          t_.payment()
        }
      })
    },
    balanceFn:function(){
      var t_=this
      if(t_.$route.query.status){
        var data={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          addressId:t_.addressId,
          status:t_.$route.query.status,
          remark:t_.msg,
          num:t_.$route.query.num,
          id:t_.balanceData.id,
          payPassword:sha1(t_.pwd),
          isUseBalance:t_.memberMoneyChecked?1:0,
          payType:t_.payTypeMode==-1?'':t_.payTypeMode,
        }
        if(t_.payTypeMode==6){
          if(window.location.host.indexOf('localhost')!=-1){
            data.returnUrl='http://'+window.location.host+'/paySuccess'
          }else{
            data.returnUrl='http://'+window.location.host+'/paySuccess'
          }
        }
        data=Qs.stringify(data)
        axios.post(`${ip}spellGroupInterface/balance`,data).then(res=>{
          if(overtime(res.data.code))return t_.goSignIn()
          if(res.data.code==300)return t_.go404(res.data.message)
          if(res.data.code==0){
            if(res.data.data.payType==0){
              t_.outTradeNo=res.data.outTradeNo 
              t_.pwd=''
              t_.maskShow=false
              t_.$store.commit('ccc')
              t_.memberMoneyChecked=false
              t_.passwordShow=false
              t_.payTypeMode=-1
              t_.$router.push({name:'paySuccess',query:{retailSpellGroupOrderId:res.data.data.retailSpellGroupOrderId}})
            }else if(res.data.payTypeMode==6){
              document.write(res.data.payData)
            }else if(res.data.payTypeMode==3){
              t_.maskShow=true
              t_.wxPayShow=true
              t_.wxPayUrl=res.data.payData
              t_.outTradeNo=res.data.outTradeNo
              t_.fn()
            }
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
            t_.pwd=''
            $('#payPwd_ .item').removeClass('circle')
            t_.passwordShowFn()
            $("#payPwd_ input:eq(0)").focus();
          }
        })
      }else{
        let data = {
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          balanceTk:t_.balanceData.balanceTk,
          payType:t_.payTypeMode==-1?'':t_.payTypeMode,
          addressId:t_.addressId,
          deliveryTime:t_.distributionType,
          isUseBalance:t_.memberMoneyChecked?1:0,
          password:sha1(t_.pwd),
          remark:t_.msg,
          isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,
          isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance
        }
        if(t_.selfExtraction)data.distribution=t_.selfExtraction
        if(t_.payTypeMode==6){
          if(window.location.host.indexOf('localhost')!=-1){
            data.returnUrl='http://'+window.location.host+'/paySuccess'
          }else{
            data.returnUrl='https://'+window.location.host+'/paySuccess'
          }
        }
        data.addPriceData=JSON.stringify(EXT_frag_depth.addPriceList)
        data.couponData=JSON.stringify(EXT_frag_depth.countyList)
        data=Qs.stringify(data)
        axios.post(`${ip}formWorkInterface/balance`,data).then(res =>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
          if(res.data.code==0){
            if(res.data.payTypeMode==6){
              document.write(res.data.payData)
            }else if(res.data.payTypeMode==3){
              t_.maskShow=true
              t_.wxPayShow=true
              t_.wxPayUrl=res.data.payData
              t_.outTradeNo=res.data.outTradeNo
              t_.fn()
            }else if(res.data.payType==1){
              t_.$router.push({name:'paySuccess',query:{orderId:res.data.id}})
            }else if(res.data.payType==0){
              t_.outTradeNo=res.data.outTradeNo 
              t_.pwd=''
              t_.maskShow=false
              t_.$store.commit('ccc')
              t_.memberMoneyChecked=false
              t_.passwordShow=false
              t_.payTypeMode=-1
              t_.$router.push({name:'paySuccess',query:{orderId:res.data.id}})
            }
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
            t_.pwd=''
            $('#payPwd_ .item').removeClass('circle')
            t_.passwordShowFn()
            $("#payPwd_ input:eq(0)").focus();
          }
        })
      }
    },
    submit:function(){
      var t_=this
      if(t_.selfExtraction==false&&!t_.addressId)return t_.$message({message:'请选择收货地址',center:true,type:'warning'})
      if(t_.memberMoneyChecked==false&&t_.payTypeMode==-1&&t_.isUseMemberCardRuleBalance==0)return t_.$message({message:'请选择支付方式',center:true,type:'warning'})
      if(t_.isUseMemberCardRuleBalance==1&&parseFloat(t_.balanceData.saleScale)!=1&&t_.memberMoneyChecked==false&&t_.payTypeMode==-1)return t_.$message({message:'请再增加一种结算方式',center:true,type:'warning'})
      if(t_.balanceData.payPassword==2)return t_.$message({message:'请设置下单密码',center:true,type:'warning'})
      var cardRuleMoney_=0
      if(t_.isUseMemberCardRuleDiscount==1){
        cardRuleMoney_=parseFloat(t_.totalAmount)*parseFloat(t_.balanceData.saleScale)
        if(t_.balanceData.cardRuleMoney<cardRuleMoney_)return t_.$message({message:'储值余额不足，请重新选择商品结算',center:true,type:'warning'})
      }else if(t_.isUseMemberCardRuleDiscount==0&&t_.isUseMemberCardRuleBalance==1){
        cardRuleMoney_=parseFloat(t_.totalAmount)>parseFloat(t_.balanceData.cardRuleMoney)?parseFloat(t_.balanceData.cardRuleMoney):parseFloat(t_.totalAmount)
      }
      if(t_.memberMoneyChecked&&t_.payTypeMode==-1){
        var total_=parseFloat(t_.balanceData.memberMoney)+cardRuleMoney_
        if(total_<parseFloat(t_.totalAmount))return t_.$message({message:'余额不足，请增加其他结算方式',center:true,type:'warning'})
        t_.passwordShowFn()
      }
      if((t_.memberMoneyChecked&&t_.payTypeMode!=-1)&&t_.isUseMemberCardRuleBalance!=1)t_.passwordShowFn()
      // if((t_.memberMoneyChecked==false&&t_.payTypeMode!=-1)&&t_.isUseMemberCardRuleBalance!=1)t_.passwordShowFn()
      if(t_.isUseMemberCardRuleBalance==1)t_.passwordShowFn()
    },
    passwordShowFn:function(){
      var t_=this
      t_.maskShow=true
      t_.passwordShow=true
      setTimeout(function(){
        $("#payPwd_").payPwd({
          max:6,
          idnex:0,
          type:"password",
          callback:function(arr) {
            t_.pwd=arr
          }
        })
        $("#payPwd_ input:eq(0)").focus();
      },t_)
    },
    passwordHideFn:function(){
      this.maskShow=false
      this.passwordShow=false
    },
    changeCouponChecked:function(obj){
      var t_=this
      if(obj.checkFlag){
        obj.checkFlag=0
        t_.couponDiscount=(parseFloat(t_.couponDiscount)-parseFloat(obj.privilege)).toFixed(t_.balanceData.decimalPlace)
        t_.totalAmount=(parseFloat(t_.totalAmount)+parseFloat(obj.privilege)).toFixed(t_.balanceData.decimalPlace)
      }else{
        obj.checkFlag=1
        t_.couponDiscount=(parseFloat(t_.couponDiscount)+parseFloat(obj.privilege)).toFixed(t_.balanceData.decimalPlace)
        t_.totalAmount=(parseFloat(t_.totalAmount)-parseFloat(obj.privilege)).toFixed(t_.balanceData.decimalPlace)
      }
      if(parseFloat(t_.freight)==0)return
      console.log( parseFloat(t_.totalAmount) , parseFloat(t_.freight) , t_.couponData.conditions )
      if(parseFloat(t_.totalAmount)-parseFloat(t_.freight)>=t_.couponData.conditions){
        t_.isFreight=true
        t_.totalAmount=(parseFloat(t_.totalAmount)-parseFloat(t_.freight)).toFixed(t_.balanceData.decimalPlace)
        t_.noFreight=true
        var n=0
        t_.noFreightNum=n.toFixed(t_.balanceData.decimalPlace)
        t_.difference=n.toFixed(t_.balanceData.decimalPlace)
      }else{
        t_.noFreight=false
        if(t_.isFreight){
          t_.isFreight=false
          t_.totalAmount=(parseFloat(t_.totalAmount)+parseFloat(t_.freight)).toFixed(t_.balanceData.decimalPlace)
        }
        t_.difference=(t_.couponData.conditions-(parseFloat(t_.totalAmount)-parseFloat(t_.freight))).toFixed(t_.balanceData.decimalPlace)
      }
    },
    changeDistribution:function(id){
      this.distributionType=id
    },
    addPirceGoodsClose:function(){
      var t_=this
      t_.addPriceList.forEach(function(item,index){
        item.checkFlag=0
      })
      t_.maskShow=false
      t_.addPirceGoodsShow=false
      t_.couponRequest()
    },
    changeAddPriceChecked:function(obj){
      if(obj.checkFlag==0){
        obj.checkFlag=1
      }else{
        obj.checkFlag=0
      }
    },
    changePayType:function(obj){
      if(this.payTypeDisabled)return
      if(obj.isChecked){
        obj.isChecked=false
        this.payTypeMode=-1
      }else{
        this.payTypeList.forEach(function(item,index){
          item.isChecked=false
        })
        obj.isChecked=true
        this.payTypeMode=obj.id
      }
    },
    moreAddressFn:function(){
      this.moreAddress=!this.moreAddress
    },
    changeAddressCityVal:function(type,obj){
      if(type==1){
        this.proId=obj.id
        this.proName=obj.name
        this.cityId=''
        this.cityName='--请选择--'
        this.countyId=''
        this.countyName='--请选择--'
        this.proListShow=false
      }else if(type==2){
        this.cityId=obj.id
        this.cityName=obj.name
        this.countyId=''
        this.countyName='--请选择--'
        this.cityListShow=false
      }else if(type==3){
        this.countyId=obj.id
        this.countyName=obj.name
        this.countyListShow=false
      }
    },
    changeAddressCity:function(type){
      if(type==1){
        this.proListShow=true
        this.getArea(0,0)
      }else if(type==2){
        this.cityListShow=true
        this.getArea(this.proId,0)
      }else if(type==3){
        this.countyListShow=true
        this.getArea(this.proId,this.cityId)
      }
    },
    getArea:function(id1,id2){
      var t_=this
      let data = Qs.stringify({
        province:id1,
        city:id2,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getArea`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          if(res.data.status==1){
            t_.proList=res.data.results
          }else if(res.data.status==2){
            t_.cityList=res.data.results
          }else if(res.data.status==3){
            t_.countyList=res.data.results
          }
        }
      })
    },
    modifyAddressFn:function(){
      this.saveaddress(this.addressId)
    },
    saveaddress:function (id) {
      var t_=this
      if(t_.proName=='--请选择--'||t_.cityName=='--请选择--'||t_.countyName=='--请选择--')return t_.$message({
        message:'请选择所在地',
        center:true,
        type:'warning'
      })
      if(!t_.modifyConsignee)return t_.$message({
        message:'请填写收货人',
        center:true,
        type:'warning'
      })
      if(t_.modifyMobilePhone){
        var re = /\d{11}$/
        if (!re.test(t_.modifyMobilePhone))return t_.$message({
          message:'请填写正确的手机号',
          center:true,
          type:'warning'
        })
      }else{
        return t_.$message({
          message:'请填写收货电话',
          center:true,
          type:'warning'
        })
      }
      if(!t_.modifyDetailAddress)return t_.$message({
        message:'请填写详细地址',
        center:true,
        type:'warning'
      })
      if(t_.landline){
        var re=/^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
        if (!re.test(t_.landline))return t_.$message({
          message:'请填写正确的座机号',
          center:true,
          type:'warning'
        })
      }
      if(t_.postalCode){
        var re=/^[0-9]{6}$/
        if (!re.test(t_.postalCode))return t_.$message({
          message:'请填写正确的邮编',
          center:true,
          type:'warning'
        })
      }
      let data={
        areaText:t_.proName+','+t_.cityName+','+t_.countyName,
        county:t_.countyId,
        consignee:t_.modifyConsignee,
        mobilePhone:t_.modifyMobilePhone,
        address:t_.modifyDetailAddress,
        telephone:t_.landline,
        postalCode:t_.postalCode,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        status:t_.modifyAddressChecked?1:2,
      }
      if(id)data.addressId=id
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/saveAddress`,data).then(res =>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.reload()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    getAddressById:function(id){
      var t_=this
      let data = Qs.stringify({tamp:localStorage.tamp?localStorage.tamp:'',channel:2,addressId:id})
      axios.post(`${ip}formWorkInterface/getAddressById`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.proName=res.data.results.proName
          t_.proId=res.data.results.proId
          t_.cityName=res.data.results.cityName
          t_.cityId=res.data.results.cityId
          t_.countyName=res.data.results.county
          t_.countyId=res.data.results.countyId
          t_.modifyConsignee=res.data.results.consignee
          t_.landline=res.data.results.telephone
          t_.modifyMobilePhone=res.data.results.mobilePhone
          t_.postalCode=res.data.results.postalCode
          t_.modifyDetailAddress=res.data.results.address
        }
        // this.myprovincearrod=false
        // this.options.forEach(function(item,index){
        //   if(item.id==res.data.results.proId){
        //     this.myprovince=item.name
        //     this.myprovinceid=item.id
        //   }
        // },this)
        // this.indexSelect()
        // setTimeout(()=>{
        //   this.mycityarrod=false
        //   this.cityoption.forEach(function(item,index){
        //     if(item.id==res.data.results.cityId){
        //       this.mycitytxt=item.name
        //       this.mycityid=item.id
        //     }
        //   },this)
        //   this.countySelect()
        //   setTimeout(()=>{
        //     this.mycountyarrod=false
        //     this.countyoption.forEach(function(item,index){
        //       if(item.id==res.data.results.countyId){
        //         this.mycountytxt=item.name
        //         this.mycountyid=item.id
        //       }
        //     },this)
        //   },150,this)
        // },150,this)
      })
    },
    modifyAddressShowFn:function(obj){
      this.maskShow=true
      this.modifyAddressShow=true
      this.getAddressById(obj.id)
    },
    modifyAddressHideFn:function(){
      this.maskShow=false
      this.modifyAddressShow=false
    },
    changeAddress:function(obj){
      var t_=this
      t_.addressList.forEach(function(item,index){
        item.status=0
      })
      obj.status=1
      t_.consignee=obj.consignee
      t_.mobilePhone=obj.mobilePhone
      t_.detailedAddress=obj.areaText+' '+obj.address
      t_.addressId=obj.id
    },
    changeMemberMoneyChecked:function(){
      if(this.isUseMemberCardRuleBalance==1){
        if(this.memberMoneyChecked){
          if(parseFloat(this.balanceData.memberMoney)>=parseFloat(this.totalAmount)*(1-parseFloat(this.balanceData.saleScale))){
            this.payTypeList.forEach(function(item,index){
              item.isChecked=false
            })
            this.payTypeDisabled=true
            this.payTypeMode=-1
          }else{
            this.payTypeDisabled=false
          }
        }else{
          this.payTypeDisabled=false
        }
      }else{
        if(this.memberMoneyChecked){
          if(parseFloat(this.balanceData.memberMoney)>parseFloat(this.totalAmount)){
            this.payTypeList.forEach(function(item,index){
              item.isChecked=false
            })
            this.payTypeDisabled=true
            this.payTypeMode=-1
          }else{
            this.payTypeDisabled=false
          }
        }else{
          this.payTypeDisabled=false
        }
      }
    },
          teamBalance:function(){
            var t_=this
            var data0bj = {
              id:t_.$route.query.confirmTeamId,
              channel: 2,
              tamp:localStorage.tamp?localStorage.tamp:'',
              status:t_.$route.query.status,
              num:t_.$route.query.num
            }
            axios.post(`${ip}spellGroupInterface/toBalance`,Qs.stringify(data0bj)).then(res=>{
              if(overtime(res.data.code))return t_.goSignIn()
              if(res.data.code==300)return t_.go404(res.data.message)
              if(res.data.code==0){
                t_.goodsList = res.data.data.goodsData
                t_.balanceData=res.data.data
                t_.freight=res.data.data.postageMoney
                t_.totalAmount=res.data.data.totalAmount

                // t_.payPassword=res.data.data.payPassword
                // t_.orderTotalNum=res.data.data.num
                // t_.orderGoodsAmount=res.data.data.goodsAmount
                // t_.postageMoney=res.data.data.postageMoney
                // t_.teamPrivilege=res.data.data.privilege
                // t_.orderMemberPrivilege=res.data.data.memberPrivilege
                // t_.$store.commit('payPassword',t_.payPassword)
                // t_.$store.commit('getGoodsAmount',res.data.data.goodsAmount)
                // t_.$store.commit('qqq',res.data.data.totalAmount)
                // t_.$store.commit('dd',res.data.data.totalAmount)
                // t_.$store.commit('vvv',res.data.data.memberMoney)
                // t_.$store.commit('lll',res.data.data.postageMoney)
                // t_.$store.commit('rrr',res.data.data.num)
                t_.$store.commit('getTeamBalanceId',res.data.data.id)
              }else{
                this.$message({
                  message:res.data.message,
                  center:true,
                  type:'warning'
                })
                // this.$router.push({name:'shopCar'})
              }
            })
          },
    toBalance:function(){
      var t_=this
      let data = {
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        cartIds:t_.$route.query.ids,
        isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,
        isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance
      }
      if(t_.$route.query.type)data.type=t_.$route.query.type
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/toBalance`,data).then(res =>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code == 0){
          t_.goodsList = res.data.data.goodsData
          t_.giftGoodsList=res.data.data.pmnGiftData
          t_.balanceData=res.data.data
          t_.promotionList=res.data.data.promotionData
          if(res.data.data.addPriceData.length){
            t_.addPriceList=res.data.data.addPriceData
            t_.maskShow=true
            t_.addPirceGoodsShow=true
          }else{
            t_.couponRequest()
          }
          // this.balanceTkStr=res.data.data.balanceTk
          // this.pmnGiftData=res.data.data.pmnGiftData
          // this.orderTotalNum=res.data.data.totalNum
          // this.orderPmnPricePrivilege=res.data.data.pmnPricePrivilege
          // this.orderCardRulePrivilege=res.data.data.cardRulePrivilege
          // this.orderMemberPrivilege=res.data.data.memberPrivilege
          // this.orderGoodsAmount=res.data.data.goodsAmount
          // this.promotionData=res.data.data.promotionData
          // this.decimalPlace=res.data.data.decimalPlace
          // this.payPassword=res.data.data.payPassword
          // this.$store.commit('payPassword',this.payPassword)
          // if(res.data.data.addPriceData.length){
          //   this.addPriceDataList=res.data.data.addPriceData
          //   this.$store.commit('addPriceDataList',this.addPriceDataList)
          //   this.isOpenAddPrice=true
          // }else{
          //   this.confirmParticipateIn()
          // }
          // if(res.data.data.balanceTk != "" || res.data.data.balanceTk != null){
          //   this.$store.commit('kkk',res.data.data.balanceTk)
          //   this.$store.commit('qqq',res.data.data.totalAmount)
          //   this.$store.commit('yyy',res.data.data.totalScore)
          //   this.$store.commit('aa',res.data.data.pmnGoodsPrivilege)
          //   this.$store.commit('bb',res.data.data.pmnOrderPrivilege)
          //   this.$store.commit('getCardRuleMoney',res.data.data.cardRuleMoney)
          //   this.$store.commit('getSaleScale',res.data.data.saleScale)
          //   this.$store.commit('getShowSaleScale',res.data.data.showSaleScale)
          //   this.$store.commit('getGoodsAmount',res.data.data.goodsAmount)
          // }else {
          //   return
          // }
        }else {
          this.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
          // this.$router.push({name:'shopCar'})
        }
      })
    },
    couponRequest:function(){
      var t_=this
      t_.maskShow=false
      t_.addPirceGoodsShow=false
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        addPriceData:JSON.stringify(t_.addPriceList),
        balanceTk:t_.balanceData.balanceTk
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/couponRequest`,data0bj).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.giftGoodsList=t_.giftGoodsList.concat(res.data.data.addPriceData)
          res.data.data.couponData.forEach(function(item,index){
            item.money=item.money.toString()
          },t_)
          t_.couponList=res.data.data.couponData
          t_.couponData=res.data.data
          t_.couponDiscount=res.data.data.pmnCouponPrivilege
          t_.freight=res.data.data.postageMoney
          t_.totalNum=res.data.data.totalNum
          t_.totalAmount=res.data.data.totalAmount
          if(t_.isUseMemberCardRuleBalance==1){
            if(t_.isUseMemberCardRuleDiscount==1&&parseFloat(res.data.data.saleScale)==1){
              t_.storedValueCardChecked=true
              t_.storedValueCardDisabled=true
              t_.memberMoneyDisabled=true
              t_.memberMoneyChecked=false
              t_.payTypeDisabled=true
              t_.payTypeMode=-1
            }else{
              t_.storedValueCardChecked=true
              t_.storedValueCardDisabled=true
            }
          }else{
            if(!parseFloat(t_.balanceData.memberMoney)){
              t_.memberMoneyDisabled=true
              t_.memberMoneyChecked=false
            }else{
              t_.memberMoneyChecked=true
              if(parseFloat(t_.balanceData.memberMoney)>parseFloat(t_.totalAmount))t_.payTypeDisabled=true
            }
          }
          if(parseInt(t_.freight))t_.difference=(t_.couponData.conditions-(parseFloat(t_.totalAmount)-parseFloat(t_.freight))).toFixed(t_.balanceData.decimalPlace)
        }
      })
    },
    getAddressByMemberId:function () {
      var t_=this
      let data = Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:1,
        pagesize:20,
        channel:2
      });
      axios.post(`${ip}formWorkInterface/getAddressByMemberId`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        t_.addressList = res.data.results.rows
        t_.addressList.forEach(function(item,index){
          if(item.status==1){
            t_.consignee=item.consignee
            t_.mobilePhone=item.mobilePhone
            t_.detailedAddress=item.areaText+' '+item.address
            t_.addressId=item.id
          }
        })
        t_.addressTotal=res.data.results.total
      })
    },
    getPayType:function(){
      var t_=this
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      }
      if(t_.$route.query.status==1)data0bj.status=1
      axios.post(`${ip}formWorkInterface/getPayType`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.payTypeList[0].isShow=res.data.wxPayStatus
          t_.payTypeList[1].isShow=res.data.zfbPayStatus
          t_.payTypeList[2].isShow=res.data.payStatus
        }
      })
    },
  }
}
</script>
<style scoped>
.pc_balance_content{
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 40px 0;
}
.pc_balance_address{
  margin-bottom: 20px;
}
.pc_balance_address_title{
  height: 35px;
  border-bottom: 2px solid #dadada;
  overflow: hidden;
}
.pc_balance_address_title_txt{
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  color: #fa0;
}
.pc_balance_address_title_extraction .el-checkbox,.pc_balance_pay_type_card_check .el-checkbox{
  border: 0;
}
.pc_balance_address_more{
  margin-top: 12px;
  cursor: pointer;
}
.pc_balance_address_list{
  padding-top: 15px;
  height: 135px;
  overflow: hidden;
}
.pc_balance_address_item{
  width: 190px;
  height: 100px;
  position: relative;
  padding: 16px;
  border-radius: 3px;
  margin-right: 22px;
  margin-bottom: 20px;
  background: url('http://img.source.9188cn.com/pc_address.png') no-repeat 0 0;
  background-size: 100% 100%;
}
.pc_balance_address_item:nth-child(5n){
  margin-right: 0;
}
.pc_balance_address_item_active{
  background: url('http://img.source.9188cn.com/pc_address_active.png') no-repeat 0 0;
  background-size: 100% 100%;
}
.pc_balance_address_item_name{
  width: 62px;
  margin-left: 20px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc_balance_address_item_phone{
  text-align: right;
  width: 80px;
  margin-left: 10px;
  line-height: 40px;
}
.pc_balance_address_item_address1,.pc_balance_address_item_address2{
  margin-left: 20px;    
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 36px;
}
.pc_balance_address_item_address2{
  line-height: 1;
}
.pc_balance_address_item_modify{
  position: absolute;
  width: 32px;
  height: 32px;
  background: url('http://img.source.9188cn.com/pc_address_modify.png') no-repeat 0 0;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
}
.pc_balance_distribution{
  margin-bottom: 20px;
}
.pc_balance_distribution_list{
  padding-top: 20px;
}
.pc_balance_distribution_item{
  margin-right: 10px;
  height: 35px;
  width: 100px;
  padding: 0 12px;
  text-align: center;
  line-height: 35px;
  border: 1px solid #e7e7e7;
  cursor: pointer;
}
.pc_balance_distribution_item_active{
  border: 1px solid #fa0;
  background: url('http://img.source.9188cn.com/pc_distribution_active.png') no-repeat 100% 100%;
  background-size: 15% 40%;
}
.pc_balance_pay_type{
  margin-bottom: 20px;
}
.pc_balance_pay_type_card_txt{
  margin-left: 40px;
  font-size: 14px;
  margin-top: 8px;
}
.pc_balance_pay_type_card_txt span{
  color:#fa0;
  font-size: 18px;
}
.pc_balance_pay_type_box{
  padding-top: 20px;
}
.pc_balance_pay_type_list{
  margin-top: 10px;
}
.pc_balance_pay_type_item{
  width: 85px;
  background: #fff;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border: 1px solid #e7e7e7;
  cursor: pointer;
  margin-right: 10px;
}
.pc_balance_pay_type_item_active{
  border: 1px solid #fa0;
  background: url(http://img.source.9188cn.com/pc_distribution_active.png) no-repeat 100% 100%;
  background-size: 15% 40%;
}
.pc_balance_pay_order{
  margin-bottom: 20px;
}
.pc_balance_pay_order_txt_box{
  padding-top: 10px;
  height: 35px;
  background: #fbfcff;
  margin-bottom: 10px;
}
.pc_balance_pay_order_txt_name{
  width: 250px;
  height: 35px;
  text-align: right;
  line-height: 35px;
  margin-right: 240px;
}
.pc_balance_pay_order_txt_price1,.pc_balance_pay_order_txt_num,.pc_balance_pay_order_txt_price2,.pc_balance_pay_order_txt_discount{
  height: 35px;
  text-align: center;
  line-height: 35px;
  width: 130px;
}
.pc_balance_pay_order_txt_price2{
  width: 170px;
}
.pc_balance_pay_order_txt_discount{
  width: 210px;
}
.pc_balance_pay_order_goods_list{
  margin-bottom: 10px;
}
.pc_balance_pay_order_goods_item{
  width: 100%;
  background: #fbfcff;
  height: 80px;
}
.pc_balance_pay_order_goods_item_pic{
  padding: 10px 0 10px 10px;
  margin-right: 30px;
}
.pc_balance_pay_order_goods_item_pic img{
  width: 60px;
  height: 60px;
}
.pc_balance_pay_order_goods_item_name{
  padding: 10px 0;
  width: 245px;
  height: 46px;
  line-height: 18px;
  margin-right: 55px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.pc_balance_pay_order_goods_item_attr{
  width: 80px;
  padding: 10px 10px 10px 0;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_balance_pay_order_goods_item_price1,.pc_balance_pay_order_goods_item_num,.pc_balance_pay_order_goods_item_price2,.pc_balance_pay_order_goods_item_discount{
  width: 130px;
  text-align: center;
  line-height: 80px;
}
.pc_balance_pay_order_goods_item_price2{
  width: 170px;
}
.pc_balance_pay_order_goods_item_discount{
  width: 210px;
}
.pc_balance_pay_order_discount_list{
  width: 300px;
}
.pc_balance_pay_order_discount_item{
  margin-bottom: 10px;
}
.pc_balance_pay_order_discount_item_txt{
  width: 150px;
  text-align: right;
}
.pc_balance_pay_order_discount_item_txt span{
  color: #ffab00;
}
.pc_balance_pay_order_discount_item_price{
  color: #ffab00;
  width: 150px;
  text-align: right;
}
.pc_balance_gift{
  margin-bottom: 20px;
}
.pc_balance_gift_txt_box{
  margin-top: 10px;
  width: 100%;
  background: #fbfcff;
  height: 35px;
}
.pc_balance_gift_txt_name{
  width: 250px;
  height: 35px;
  text-align: right;
  line-height: 35px;
  margin-right: 240px;
}
.pc_balance_gift_txt_num,.pc_balance_gift_txt_price{
  width: 130px;
  height: 35px;
  text-align: center;
  line-height: 35px;
}
.pc_balance_promotion{
  margin-bottom: 20px;
}
.pc_balance_promotion_txt{
  width: 25%;
  line-height: 50px;
  text-align: center;
}
.pc_balance_promotion_item_txt{
  width:25%;
  text-align: center;
  line-height:20px;
  height:20px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_balance_coupon{
  margin-bottom: 20px;
}
.pc_balance_coupon_list{
  margin-top: 20px;
}
.pc_balance_coupon_item{
  width: 280px;
  height: 69px;
  margin-right: 26px;
  background: #fff;
}
.pc_balance_coupon_item_radio{
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}
.pc_balance_coupon_item_radio img{
  width: 20px;
  height: 20px;
}
.pc_balance_coupon_item_box{
  width: 250px;
  height: 69px;
  position: relative;
}
.pc_balance_coupon_item_bg{
  width: 250px;
  height: 69px;
  position: absolute;
  top: 0;
  left: 0;
}
.pc_balance_coupon_item_bg{
  width: 250px;
  height: 69px;
}
.pc_balance_coupon_item_rmb{
  position: absolute;
  top:20px;
  left:10px;
  color:#fff;
  font-size: 20px;
}
.pc_balance_coupon_item_price1{
  position: absolute;
  top: 5px;
  left: 28px;
  color: #fff;
  font-size: 38px;
}
.pc_balance_coupon_item_price2{
  position: absolute;
  top: 9px;
  left: 21px;
  color: #fff;
  font-size: 34px;
}
.pc_balance_coupon_item_price3{
  position: absolute;
  top: 9px;
  left: 21px;
  color: #fff;
  font-size: 34px;
}
.pc_balance_coupon_item_price4{
  position: absolute;
  top: 18px;
  left: 25px;
  color: #fff;
  font-size: 24px;
}
.pc_balance_coupon_item_txt1{
  width: 110px;
  position: absolute;
  top: 15px;
  left: 110px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 900;
  color: #66604a;
}
.pc_balance_coupon_item_time{
  position: absolute;
  top: 45px;
  left: 110px;
  color: #ababab;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc_balance_coupon_item_txt2{
  position: absolute;
  top: 45px;
  left: 20px;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  color: #fff;
}
.pc_balance_discount{
  margin-top: 60px;
  margin-bottom: 60px;
}
.pc_balance_discount_remark{
  width: 610px;
  height: 42px;
}
.pc_balance_discount_remark_txt{
  width: 80px;
  height: 42px;
  line-height: 42px;
}
.pc_balance_discount_remark_input textarea{
  resize: none;
  padding: 10px;
  width: 500px;
  height: 20px;
  overflow-y: auto;
  border: 1px solid #ccc;
}
.pc_balance_discount_list{
  width: 590px;
}
.pc_balance_discount_list1{
  width: 250px;
  margin-left: 25px;
}
.pc_balance_discount_list1_item,.pc_balance_discount_list2_item{
  margin-bottom: 10px;
}
.pc_balance_discount_list1_item .fr,.pc_balance_discount_list2_item .fr{
  color: #e00;
}
.pc_balance_discount_list2_item_txt{
  float: right;
}
.pc_balance_discount_list2{
  width: 250px;
}
.pc_balance_price{
  background: #f2f2f2;
  padding: 7px 15px;
}
.pc_balance_total_price{
  line-height: 40px;
  text-align: right;
}
.pc_balance_total_price span{
  color: #e00;
  font-size: 22px;
}
.pc_balance_price_address{
  text-align: right;
  line-height: 40px;
}
.pc_balance_price_address span{
  display: inline-block;
  margin-right: 20px;
}
.pc_balance_price_address span:last-child{
  margin-right: 0;
}
.pc_balance_price_btn{
  margin-top: 15px;
}
.pc_balance_price_btn .fr{
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  background: #fa0;
  color: #fff;
  cursor: pointer;
}
.pc_balance_mask{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .2);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
}
.pc_balance_modify_address{
  width: 600px;
  height: 445px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -300px;
  margin-top: -200px;
  z-index: 10;
  border-radius: 5px;
}
.pc_balance_modify_address_title_box{
  height: 50px;
  background: #f3f3f3;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.pc_balance_modify_address_title{
  font-size: 14px;
  line-height: 50px;
  text-align: center;
}
.pc_balance_modify_address_close{
  padding: 0 15px;
  line-height: 35px;
  font-size: 18px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.pc_balance_modify_address_content{
  padding: 10px;
  margin-bottom: 5px;
}
.pc_balance_modify_address_item_txt{
  text-align: center;
  width: 100px;
  height: 40px;
  line-height: 40px;
}
.pc_balance_modify_address_item_txt span{
  color: #e00;
}
.pc_balance_modify_address_item_location{
  margin-top: 7px;
}
.pc_balance_modify_address_item_location_item{
  width: 100px;
  height: 25px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  margin-right: 10px;
}
.pc_balance_modify_address_item_location_item_txt{
  width: 102px;
  height: 27px;
  line-height: 25px;
  text-align: center;
}
.pc_balance_modify_address_item_location_val_list{
  width: 100px;
  height: 130px;
  border: 1px solid #ccc;
  position: absolute;
  left: 0px;
  top: 28px;
  overflow-y: auto;
  z-index: 9;
  background: #fff;
}
.pc_balance_modify_address_item_location_val_list_val{
  width: 100%;
  height: 28px;
  text-align: center;
  line-height: 28px;
}
.pc_balance_modify_address_item_input{
  width: 200px;
  height: 25px;
  border: 1px solid #ccc;
  margin-top: 7px;
}
.pc_balance_modify_address_item_input input{
  width: 180px;
  height: 25px;
  padding: 0 10px;
  outline: none;
}
.pc_balance_modify_address_item_textarea{
  width: 320px;
  height: 60px;
  resize: none;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-top: 7px;
}
.pc_balance_modify_address_item_textarea textarea{
  outline: none;
  width: 310px;
  height: 50px;
  padding: 5px;
}
.pc_balance_modify_address_item_switch{
  width: 40px;
  height: 20px;
  margin-top: 9px;
}
.pc_balance_modify_address_btn>div{
  width: 100px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin: 0 auto;
  line-height: 35px;
  color: #fff;
  background: #fa0;
  border-radius: 3px;
  cursor: pointer;
}
input[type=number] {  
  -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
  -webkit-appearance: none;  
  margin: 0;  
}
.pc_balance_addPriceGoods{
  width: 912px;
  height: 550px;
  margin: 0 auto;
  background: #fff;
  margin-top: 100px;
  overflow-y: auto;
  border: 1px solid #b5b5b5;
  border-radius: 15px;
}
.pc_balance_addPriceGoods_title{
  padding: 20px 25px 0 25px;
}
.pc_balance_addPriceGoods_title_txt{
  font-size: 18px;
  color: #ffab00;
  font-weight: 900;
  margin-bottom: 45px;
}
.pc_balance_addPriceGoods_title_close{
  width: 18px;
  height: 18px;
}
.pc_balance_addPriceGoods_title_close img{
  width: 18px;
  height: 18px;
}
.pc_balance_addPriceGoods_txt{
  height: 35px;
}
.pc_balance_addPriceGoods_txt_name{
  margin-right: 20px;
  text-align: center;
  width: auto;
  margin-left: 200px;
  line-height: 35px;
}
.pc_balance_addPriceGoods_txt_num{
  width: 115px;
  margin-left: 141px;
  text-align: center;
  line-height: 35px;
}
.pc_balance_addPriceGoods_txt_price{
  width: 115px;
  text-align: center;
  line-height: 35px;
}
.pc_balance_addPriceGoods_btn1{
  width: 80px;
  line-height: 32px;
  text-align: center;
  background: #a3a3a3;
  border-radius: 5px;
  border: 0;
  color: #fff;
  cursor: pointer;
  margin-right: 50px;
}
.pc_balance_addPriceGoods_btn2{
  background: #ffab00;
  margin-right: 0;
}
.pc_balance_addPriceGoods_btn_auto{
  width: 210px;
  margin: 0 auto;
}
.pc_balance_addPriceGoods_list{
  margin-top: 10px;
  margin-bottom: 20px;
  height: 350px;
  overflow-y: auto;
}
.pc_balance_addPriceGoods_item{
  padding: 0 15px;
  margin-bottom: 10px;
  background: #fbfcff;
  height: 80px;
}
.pc_balance_addPriceGoods_item_radio{
  width: 20px;
  height: 20px;
  margin: 28px 5px 0 0;
}
.pc_balance_addPriceGoods_item_radio img{
  width: 20px;
  height: 20px;
}
.pc_balance_addPriceGoods_item_pic{
  padding: 10px;
  width: 60px;
  height: 60px;
  margin-right: 10px;
}
.pc_balance_addPriceGoods_item_pic img{
  width: 60px;
  height: 60px;
}
.pc_balance_addPriceGoods_item_name{
  padding: 10px;
  width: 245px;
  margin-right: 15px;
}
.pc_balance_addPriceGoods_item_name_txt1{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 18px;
  margin-bottom: 10px;
}
.pc_balance_addPriceGoods_item_num,.pc_balance_addPriceGoods_item_price{
  text-align: center;
  line-height: 80px;
  width: 115px;
}
.pc_balance_password_box{
  height: 250px;
  width: 470px;
  background: #fff;
  z-index: 10;
  border-radius: 5px;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
}
.pc_balance_password_title{
  width: 100%;
  height: 50pxpx;
  text-align: center;
  line-height: 50px;
  background: #f3f3f3;
  font-size: 14px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.pc_balance_password{
  padding: 10px;
}
.pc_balance_password_num{
  width: 56%;
  margin:0rem auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top:20px;
}
.flex-1{
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 0;
  -webkit-flex-basis: 0;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
}
.pwd-control {padding: 1rem 0 2.5rem;text-align: center;height: 67px;}
.pwd-control .item {margin: 0 3px;position: relative;}
.pwd-control .item.circle:after {content: "";width: 8px;height: 8px;background: #000;border-radius: 50%;position: absolute;top: 50%;left: 50%;margin-top: -4px;margin-left: -4px;}
.pwd-control .normal input {color: #000;}
.pwd-control input {display: block;width: inherit;border-radius: 3px;text-align: center;border: 1px solid #c79f62;width: 100%;color: #fff;line-height: 35px}
.pwd-control input:focus {box-shadow: 0px 0px 20px #c79f62;}
.pwd-control .box {padding: 0rem;}
.pc_balance_btn_box{
  text-align: center;
}
.pc_balance_wx{
  width: 300px;
  height: 320px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
}
.pc_balance_wx_img{
  width: 300px;
  height: 300px;
}
.pc_balance_wx_img img{
  width: 300px;
  height: 300px;
}
.pc_balance_wx_txt{
  color: #fff;
  line-height: 20px;
  text-align: center;
}
.pc_balance_wx_close{
  width: 32px;
  height: 32px;
  position: absolute;
  top: -40px;
  right: -40px;
  cursor: pointer;
}
.pc_balance_wx_close img{
  width: 32px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settlement/index.vue